import { AuthService } from '../../../../../core/api/auth.service';
import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { CustomerService } from '../../../../../core/services/customer.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
	selector: 'm-user-profile',
	templateUrl: './user-profile.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserProfileComponent implements OnInit {
	decodedToken: any;
	nameSurname: string;
	email: string;
	role: string;

	@HostBinding('class')
	classes = 'm-nav__item m-topbar__user-profile m-topbar__user-profile--img m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light';

	@HostBinding('attr.m-dropdown-toggle') attrDropdownToggle = 'click';

	@Input() avatar: string = './assets/app/media/img/users/user4.jpg';
	@Input() avatarBg: SafeStyle = '';

	@ViewChild('mProfileDropdown') mProfileDropdown: ElementRef;

	constructor(
		private router: Router,
		private authService: AuthService,
		private sanitizer: DomSanitizer,
		public customerService: CustomerService,
		private jwtHelper: JwtHelperService
	) { }

	ngOnInit(): void {
		const token = localStorage.getItem('token');

		if (token && !this.jwtHelper.isTokenExpired(token)) {
			this.decodedToken = this.jwtHelper.decodeToken(token);
			this.bindUserNameSurname();
		} else {
			this.logout();
		}

		if (!this.avatarBg) {
			this.avatarBg = this.sanitizer.bypassSecurityTrustStyle('url(./assets/app/media/img/misc/user_profile_bg.jpg)');
		}
	}

	bindUserNameSurname() {
		this.nameSurname = this.decodedToken.given_name + ' ' + this.decodedToken.family_name;
		this.email = this.decodedToken.unique_name;
		const roleNo = this.decodedToken.role;
		if (roleNo == '1') this.role = 'Sistem Yöneticisi';
		if (roleNo == '2') this.role = 'Şirket Yöneticisi';
		if (roleNo == '3') this.role = 'Şirket Kullanıcısı';
	}

	public logout() {
		this.authService.logOut();
	}
}
